import { createSlice } from '@reduxjs/toolkit'

export const configSlice = createSlice({
    name: 'config',
    initialState: { 
        base_url    : process.env.NODE_ENV === 'production' ? 'https://crowdbees.binus.ac.id' : 'http://localhost:3000'
        ,api_url    : process.env.NODE_ENV === 'production' ? 'https://api-crowdbees.apps.binus.ac.id/wp-json/crowdbees/v1' : 'http://localhost/crowdbees-api/wp-json/crowdbees/v1'
        ,auth       : {
            basic      : 'Basic Y3Jvd2RiZWVzOmNyb3dkYmVlc19rMzQ='
        }
        ,InitiativeTypes : {
            research : {
                name : 'Research Activity'
            }
            ,event : {
                name : 'Event Crew'
            }
            ,talent : {
                name : 'Talent Team'
            }
            ,other : {
                name : 'Other'
            }
        }
        ,BGA : [
            ['global-tech', 'Global Standard Technical Competencies']
            ,['digital-fluency', 'Digital & Technology Fluency']
            ,['applied-skills', 'Applied Management Skills']
            ,['critical-thinking', 'Critical & Creative Thinking']
            ,['adaptability', 'Adaptability']
            ,['initiative', 'Initiative']
            ,['growth-mindset', 'Growth Mindset']
            ,['collaboration', 'Collboration']
            ,['social-awareness', 'Social Awareness']
        ]
        ,campus : [
            ['syahdan', 'Syahdan Campus']
            ,['anggrek', 'Anggrek Campus']
            ,['kijang', 'Kijang Campus']
            ,['jwc', 'JWC Campus']
            ,['fx', 'BINUS FX']
            ,['alamsutera', 'BINUS @Alam Sutera']
            ,['bandung', 'BINUS @Bandung']
            ,['malang', 'BINUS @Malang']
            ,['semarang', 'BINUS @Semarang']
        ]
        ,EventLevel : [
            ['provinsi', 'Provinsi']
            ,['binus', 'BINUS']
            ,['regional', 'Regional']
            ,['nasional', 'Nasional']
            ,['internasional', 'Internasional']
        ]
        ,EventForms : [
            ['online', 'Online']
            ,['onsite', 'Onsite']
            ,['hybrid', 'Hybrid']
        ]
        ,ResearchOutput : [
            ['rnd', ' RnD Prototype']
            ,['prototipe', ' Industry Prototype']
            ,['community-research', 'Research used by the community']
            ,['industry-product', 'Innovative products used by industry']
        ]
        ,ResearchType : [
            ['basic','Basic Research']
            ,['applied','Applied Research']
            ,['development','Advanced Research']
        ]
    }
    ,reducers : {}
});

export default configSlice.reducer;